import { isValidNumber } from '@/utils/isValidNumber';

export async function fetchQuote(symbol: string) {
  const urlSearchParams = new URLSearchParams({
    s: symbol,
    f: 'json',
    randomNumber: Date.now().toString()
  });

  let responseJson;

  try {
    const response = await fetch(`/quotebrain/quotes?${urlSearchParams.toString()}`, {
      method: 'GET'
    });

    responseJson = await response.json();

    window.sc3WorkbenchLogger.info(`quote responseJson for symbol: ${symbol}`, responseJson);
  } catch (e) {
    window.sc3WorkbenchLogger.error(`Failed to fetch quote for symbol: ${symbol}.`, e);

    throw new Error(`Failed to fetch quote for symbol: ${symbol}.`, { cause: e });
  }

  if (!responseJson) {
    throw new Error(`Failed to fetch quote for symbol: ${symbol} - responseJson is falsy: ${typeof responseJson} ${responseJson}.`);
  }

  if (typeof responseJson !== 'object') {
    throw new Error(`Failed to fetch quote for symbol: ${symbol} - responseJson is truthy but is not an object: ${typeof responseJson}.`);
  }

  if (!Array.isArray(responseJson)) {
    throw new Error(`Failed to fetch quote for symbol: ${symbol} - responseJson is a truthy object but is not an array.`);
  }

  if (!responseJson.length) {
    throw new Error(`Failed to fetch quote for symbol: ${symbol} - responseJson is an empty array.`);
  }

  if (responseJson.length > 1) {
    throw new Error(`Failed to fetch quote for symbol: ${symbol} - responseJson.length is greater than 1: ${responseJson.length}.`);
  }

  if (!responseJson[0]) {
    throw new Error(`Failed to fetch quote for symbol: ${symbol} - responseJson[0] is falsy: ${typeof responseJson[0]} ${responseJson[0]}.`);
  }

  if (typeof responseJson[0] !== 'object') {
    throw new Error(`Failed to fetch quote for symbol: ${symbol} - responseJson[0] is truthy but is not an object: ${typeof responseJson[0]}.`);
  }

  if (!isValidNumber(responseJson[0].close)) {
    throw new Error(`Failed to fetch quote for symbol: ${symbol} - responseJson[0].close is not a valid number: ${typeof responseJson[0].close}.`);
  }

  return responseJson[0];
}
